function debounce(func, wait, immediate) {
  var timeout;
  return {
    func: function() {
      var context = this,
          args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    },
    cancel: function() {
      clearTimeout(timeout);
    }
  };
}

window.wbPicture = (function() {
  // [0]: hostname + pathname
  // [1]: size (_100x or _x100 or _100x100)
  // [2]: crop (_crop_top, _crop_bottom, etc.)
  // [3]: scale (undefined or @2x or @3x)
  // [4]: format (.png or .jpg)
  // [5]: version (?v=1234)
  var replaceImgRegex = /(_\d+x\d+|_\d+x|_x\d+)?(_crop_\w+)?(@\dx)?(\.jpg|\.png|\.gif|\.mp4)(\?v=\d+)?/;

  function replaceImgUrlAdvanced(oldSrc, newSrc, options) {
    var oldParts = oldSrc.split(replaceImgRegex);
    var newParts = newSrc.split(replaceImgRegex);
    oldParts[0] = newParts[0];
    if (options) {
      if (options.master) {
      oldParts[1] = '';
      oldParts[2] = newParts[2];
      oldParts[3] = '';
      }
      if (options.size) {
        oldParts[1] = '_' + options.size;
      }
      if (options.crop) {
        oldParts[2] = '_crop_' + options.crop;
      }
    }
    oldParts[4] = newParts[4];
    oldParts[5] = newParts[5];
    return oldParts.join('');
  }

  function replaceImgSrcsetUrlsAdvanced(oldSrcset, newSrc, options) {
    return oldSrcset.split(/, ?/).map(function(part) {
      return replaceImgUrlAdvanced(part, newSrc, options);
    }).join(', ');
  }

  function replaceImgSrc(img, src, options) {
    if ((img.dataset && img.dataset.wasProcessed) || (typeof img.src !== 'undefined' && img.src)) {
      img.src = replaceImgUrlAdvanced(img.src, src, options);
    } else {
      img.dataset.src = replaceImgUrlAdvanced(img.dataset.src, src, options);
    }
  }

  function replaceSourcesSrc(sources, src, options) {
    sources.forEach(function(source) {
      if (typeof source.srcset !== 'undefined' && source.srcset) {
        source.srcset = replaceImgSrcsetUrlsAdvanced(source.srcset, src, options)
      } else {
        source.dataset.srcset = replaceImgSrcsetUrlsAdvanced(source.dataset.srcset, src, options);
      }
    });
  }

  function replaceDataZoomSrc(img, src, options) {
    if (img.dataset && typeof img.dataset.zoomSrc !== 'undefined' && img.dataset.zoomSrc) {
      img.dataset.zoomSrc = replaceImgUrlAdvanced(img.dataset.zoomSrc, src);
    }
  }

  function replaceDataMagnifySrc(img, src, options) {
    if (img.dataset && typeof img.dataset.magnifySrc !== 'undefined' && img.dataset.magnifySrc) {
      img.dataset.magnifySrc = replaceImgUrlAdvanced(img.dataset.magnifySrc, src, options);
    }
  }

  function replacePictureSrcAdvanced(element, src, options) {
    var elements = [];
    if (typeof jQuery === 'function' && element instanceof jQuery) {
      elements = Array.prototype.slice.call(element.toArray());
    } else if (!Array.isArray(element)) {
      elements = [element];
    }

    elements.filter(function (element) { return Boolean(element); }).forEach(function(element) {
      if (element !== null && element.tagName === 'IMG') {
        element = element.closest('picture');
      }
      if (element !== null && element.tagName !== 'PICTURE') {
        element = element.querySelector('picture') || element.querySelector('img');
      }
      if (element !== null && ['PICTURE', 'IMG'].indexOf(element.tagName) !== -1) {
        var img = element.tagName === 'IMG' ? element : element.getElementsByTagName('img')[0];
        var sources = Array.prototype.slice.call(element.getElementsByTagName('source'));
        replaceImgSrc(img, src, options);
        replaceSourcesSrc(sources, src, options);
        replaceDataZoomSrc(img, src, options);
        replaceDataMagnifySrc(img, src, options);
      }
    });
  }

  return {
    replaceSrc: replacePictureSrcAdvanced
  };

})();



document.addEventListener('DOMContentLoaded', function() {
  //Additional FB& IG Tracking
  function addToCartAd(){
    if (Cookies.get('adfb') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="FB"></option></select>');
    }else if(Cookies.get('adig') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="IG"></option></select>');
    }
  }
  addToCartAd();

  window.wbProductZoom = (function() {
    var id = 'product_zoom',
        idSmile = 'smile-ui-container',
        idButtonClose = 'product_zoom_close',
        idMobile = 'product_zoom_mobile',
        idMobileIconWrapper = 'product_zoom_icon_wrapper',
        idMobilePinch = 'product_zoom_mobile_pinch',
        idDesktopSwiper = 'product_zoom_desktop_swiper',
        classShow = 'wb-product-zoom--show',
        classMobileImg = 'wb-product-zoom-mobile__img',
        classMobileImgMaster = 'wb-product-zoom-mobile__img--master',
        classMasterShow = 'wb-product-zoom-mobile__img--master-show',
        classDesktopZoomContainer = 'wb-product-zoom-desktop__swiper-zoom-container',
        // The desktop equivalents of classMobileImgMaster / classMasterShow. The marker class
        // is added to the slide's master <img> only when an interim render is put underneath
        // it, so a slide with nothing behind it is never hidden waiting for a load event.
        classDesktopPreview = 'wb-product-zoom-desktop__preview',
        classDesktopMaster = 'wb-product-zoom-desktop__img--master',
        classDesktopMasterShow = 'wb-product-zoom-desktop__img--master-show',
        // Width of the interim render shown while the master original downloads. Chosen
        // against the rendered size, not the source: the slide is about 800 CSS px wide and
        // the mouse zoom doubles that, so 1600 is 1:1 at full zoom on a standard display.
        DESKTOP_PREVIEW_WIDTH = 1600,
        // The master <img> of the slide currently showing an interim render, or null. The
        // mouse zoom is suppressed while it is set, so the preview is never magnified past
        // its own resolution.
        //
        // The element rather than a bare boolean: each preview arms its own one-shot `load`
        // listener that releases the hold, and those outlive the slide they were armed for.
        // A slow master on slide 1, closed and re-opened on slide 3, would otherwise land and
        // release slide 3's hold — magnifying slide 3's interim render 2x, which is exactly
        // what the hold exists to prevent.
        desktopZoomHeldBy = null,
        // The zoom slide image the server renders with data-src and no src. LazyLoad keeps
        // this class after loading (it is the instance's elements_selector), so it identifies
        // the master both before and after.
        selectorDesktopMaster = 'img.slider-lazy',
        // Zoom originals already requested by warm(), keyed by url. Keyed by url rather than
        // by slide index because a colour switch replaces the slides with a different set of
        // urls, which invalidates itself.
        warmed = {},
        elZoom,
        elButton,
        elMobile,
        pinchZoom,
        elIcon,
        elPinch,
        elPictureWrapper,
        elPictureCanvas,
        elPictureImg,
        elPictureImgMaster,
        elVideo,
        elDesktopSwiper,
        // Which of the two overlays was opened. The desktop and mobile halves have entirely
        // separate setup — initMobile() builds the PinchZoom container and the master <img>,
        // initDesktop() builds the Swiper — so the teardown has to match the setup that ran,
        // not whatever the viewport measures at close time. Left undefined until the first
        // open, when hide() falls back to measuring.
        openedDesktop,
        rectDesktopWrapper;

    function measureScrollbarWidth() {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      var scrollbarWith = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWith;
    }

    function setScrollbarAdjustments() {
      var rect = document.body.getBoundingClientRect();
      var isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      var scrollbarWidth = measureScrollbarWidth();

      if (isBodyOverflowing) {
        // Adjust body padding
        var actualPadding = document.body.style.paddingRight;
        var actualOverflow = document.body.style.overflow;
        var calculatedPadding = window.getComputedStyle(document.body).paddingRight;

        document.body.dataset.paddingRight = actualPadding;
        document.body.dataset.overflow = actualOverflow;
        document.body.style.paddingRight = (parseFloat(calculatedPadding) + scrollbarWidth) + 'px';
        document.body.style.overflow = 'hidden';
      }
    }

    function resetScrollbarAdjustments() {
      var padding = document.body.dataset.paddingRight;
      var overflow = document.body.dataset.overflow;
      if (typeof padding === 'undefined') {
        document.body.style.paddingRight = '';
      } else {
        document.body.dataset.paddingRight = '';
        document.body.dataset.overflow = '';
        document.body.style.paddingRight = padding;
        document.body.style.overflow = overflow;
      }
    }

    function isDesktop() {
      return window.getComputedStyle(elMobile).display === 'none';
    }

    function resetZoom() {
      if (!elPinch.style.height) {
        pinchZoom.setContainerY(elZoom.clientHeight);
      }

      var scaleX = pinchZoom.getContainerX() / pinchZoom.el.clientWidth;
      var scaleY = pinchZoom.getContainerY() / pinchZoom.el.clientHeight;
      var scale = Math.max(scaleY, pinchZoom.el.clientHeight / pinchZoom.getContainerY());
      var scaleOffset = Math.max(scaleY, scaleX);
      pinchZoom.initialOffset.x = (pinchZoom.getContainerX() - pinchZoom.el.clientWidth) / 2;
      pinchZoom.initialOffset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight) / 2;
      pinchZoom.offset.x = (pinchZoom.getContainerX() * scaleOffset - pinchZoom.el.clientWidth) / 2;
      pinchZoom.offset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight * scaleOffset) / 2;
      pinchZoom.zoomFactor = scale;
      pinchZoom.lastScale = scale;
      pinchZoom.options.minZoom = scale;
      pinchZoom.options.zoomOutFactor = scale;
      pinchZoom.update();
    }

    function reset() {
      // Nothing to reset on desktop: the overlay's Swiper is dropped wholesale by
      // resetDesktop() and rebuilt by the next open, so there is no per-open state here that
      // survives to be put back. (This branch used to call an empty resetSwiper().)
      if (!isDesktop()) {
        resetZoom();
      }
    }

    // Drop the desktop gallery's Swiper so the next open builds one over whatever markup is in
    // #product_zoom by then. The colour switch replaces those slides (pdp-color-switch.js:
    // swapZoomGallery) and clearing elDesktopSwiper is the half that cannot be done from
    // outside: initDesktop() early-returns while it is set, so a switched-to colour would open
    // on an uninitialised stack of slides. Nothing is rebuilt here on purpose — initDesktop()
    // runs from showDesktop(), after classShow is on, which is the only point Swiper can
    // measure a container the overlay keeps hidden until then.
    function resetDesktop() {
      // The overlay is normally shut when a colour is picked — it covers the swatch rail — but
      // pdp-color-switch also switches on popstate, so Back with the lightbox open would pull
      // the slides out from under a visible overlay. Close it first, which also puts the
      // scrollbar adjustments back.
      if (elZoom && elZoom.classList.contains(classShow)) {
        hide();
      }

      if (!elDesktopSwiper) {
        return;
      }
      // Swiper 5 deletes an instance's own properties on destroy, so re-entering this would
      // throw on the missing method rather than no-op.
      if (typeof elDesktopSwiper.destroy === 'function' && !elDesktopSwiper.destroyed) {
        elDesktopSwiper.destroy(true, true);
      }
      // undefined, not null: setupSwiper() gates on `typeof elDesktopSwiper !== 'undefined'`.
      elDesktopSwiper = undefined;
    }

    // The slide the shopper is about to land on, by the same index showDesktop slides to.
    function desktopSlideAt(index) {
      var slides = document.querySelectorAll('#' + idDesktopSwiper + ' .swiper-slide');
      return slides[index] || null;
    }

    // A bounded render of the same image, for the slide to show while the master original
    // downloads. Derived from the master url with the Shopify CDN's width parameter — the same
    // mechanism index.layout.js uses on swatch images (`${variantImage}?width=200`).
    //
    // Deliberately not a clone of the gallery <picture> the shopper clicked. That would cost
    // nothing, being already cached, but the gallery serves 330–650px per breakpoint and the
    // zoom slide renders at roughly 800 CSS px (height: 100% of the overlay, width auto) and
    // twice that under the mouse zoom — a ~3.5x upscale, which looks exactly like what it is.
    // At DESKTOP_PREVIEW_WIDTH the same frame is effectively 1:1 at scale 1 on a 2x display and
    // at scale 2 on a 1x one, so it reads as the finished image rather than as a placeholder.
    function previewUrl(masterUrl) {
      if (!masterUrl) {
        return null;
      }
      return masterUrl + (masterUrl.indexOf('?') === -1 ? '?' : '&') + 'width=' + DESKTOP_PREVIEW_WIDTH;
    }

    // Put that render into the slide being opened, under the master image, and fade the master
    // in over it on load. product-image-zoom.liquid renders those slides at img_url: 'master'
    // — the unbounded original — behind a data-src, so without this nothing is in flight until
    // the overlay opens and the frame is empty for the whole transfer.
    //
    // The layering is the same one showMobile has always used, and needs no layout CSS of its
    // own: both images are .wb-picture__img inside the one .wb-picture-wrapper, which is
    // position: relative with the canvas as its only in-flow child, so they stack by themselves
    // (womensbest.scss.liquid). Only the opacity pair is new, and it copies the mobile one.
    //
    // Deliberately only the slide being opened, not all of them. The index comes from the
    // clicked image's data-index, which is the same number showDesktop hands the swiper — so
    // the preview lands on whatever slide the shopper lands on, by construction. Seeding every
    // slide would need that mapping to be independently correct for each one, and the zoom
    // gallery inserts an extra video slide for some products.
    function showDesktopPreview(index) {
      var slide = desktopSlideAt(index);
      var wrapper = slide ? slide.querySelector('.wb-picture-wrapper') : null;
      var master = wrapper ? wrapper.querySelector(selectorDesktopMaster) : null;
      if (!master) {
        return;
      }

      // Reopening a slide whose master is already decoded: there is nothing to cover, and a
      // preview over it would replace a finished image with a smaller one.
      if (master.complete && master.naturalWidth > 0) {
        return;
      }
      if (wrapper.querySelector('.' + classDesktopPreview)) {
        return;
      }

      var url = previewUrl(master.getAttribute('data-src'));
      if (!url) {
        return;
      }

      var preview = document.createElement('img');
      preview.className = 'wb-picture__img ' + classDesktopPreview;
      // Decorative: the master underneath carries the real alt text, and announcing the same
      // image twice helps nobody.
      preview.alt = '';
      preview.src = url;

      // Both events, not just `load`. A master that 404s or is cut off mid-transfer never
      // fires `load`, so it used to keep the opacity-0 class for good — clearDesktopPreviews
      // only strips that from a master that decoded, and it removes the preview underneath
      // either way, leaving an empty frame for anyone who swipes back to that slide. Showing
      // a broken image is what a slide with no preview would have shown anyway, and the hold
      // has to be released on this path too or the mouse zoom stays dead.
      var onMasterSettled = function() {
        master.classList.add(classDesktopMasterShow);
        if (desktopZoomHeldBy === master) {
          desktopZoomHeldBy = null;
        }
      };

      master.classList.add(classDesktopMaster);
      master.addEventListener('load', onMasterSettled, { once: true });
      master.addEventListener('error', onMasterSettled, { once: true });

      // The mouse zoom magnifies by 2, and only on a high-density display does that take the
      // preview past its own resolution: at DESKTOP_PREVIEW_WIDTH it is already 1:1 at full
      // zoom on a 1x screen, so holding there would cost responsiveness for nothing. Released
      // when the master settles, above.
      desktopZoomHeldBy = window.devicePixelRatio > 1 ? master : null;

      wrapper.insertBefore(preview, master);
    }

    // Put the slides back the way the server rendered them. A master that never loaded keeps
    // its hidden class, so the next open re-inserts a preview and waits again; one that did
    // load is already opaque and simply loses the layer underneath it.
    function clearDesktopPreviews() {
      desktopZoomHeldBy = null;
      var previews = document.querySelectorAll('#' + idDesktopSwiper + ' .' + classDesktopPreview);
      for (var i = 0; i < previews.length; i++) {
        var wrapper = previews[i].parentNode;
        if (!wrapper) {
          continue;
        }
        var master = wrapper.querySelector(selectorDesktopMaster);
        if (master && master.complete && master.naturalWidth > 0) {
          master.classList.remove(classDesktopMaster);
          master.classList.remove(classDesktopMasterShow);
        }
        wrapper.removeChild(previews[i]);
      }
    }

    function hideSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = 'none';
      }
    }

    function showSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = '';
      }
    }

    function updateHTMLPosition() {
      hideSmile();
      setTimeout(function() {
        if (!isDesktop()) {
          document.body.appendChild(elZoom);
        }
        hideSmile();
      }, 500);
    }

    function getRectDesktopWrapper() {
      rectDesktopWrapper = document.querySelector('#' + idDesktopSwiper + ' .swiper-wrapper').getBoundingClientRect(window);
    }

    var onResize = debounce(getRectDesktopWrapper, 200);

    // Dispatches on how the overlay was opened, not on isDesktop(). The viewport can change
    // while the lightbox is up — a resized window, a rotated tablet — and the mobile branch
    // dereferences elPictureImgMaster and pinchZoom, which only initMobile() ever creates. A
    // desktop-opened overlay measured as mobile therefore threw a TypeError, and since
    // pdp-color-switch calls this synchronously (swapZoomGallery -> resetDesktop -> hide) the
    // throw landed mid-swap and reloaded the page with the DOM half switched.
    function hide() {
      elZoom.classList.remove(classShow);
      showSmile();
      var wasDesktop = typeof openedDesktop === 'boolean' ? openedDesktop : isDesktop();
      if (wasDesktop) {
        resetScrollbarAdjustments();
        clearDesktopPreviews();
        window.removeEventListener('resize', onResize.func, false);
      } else {
        if (elPictureImg) {
          elPictureWrapper.removeChild(elPictureImg);
          elPictureImg = null;
        }
        if (elVideo) {
          elPictureWrapper.removeChild(elVideo);
          elVideo = null;
        }
        // Absent if the mobile overlay was never opened — hide() also runs from resetDesktop()
        // on a colour switch, which can be the first thing that ever closes it.
        if (elPictureImgMaster) {
          elPictureImgMaster.classList.remove(classMasterShow);
          elPictureImgMaster.src = '';
        }
        if (pinchZoom) {
          resetZoom();
        }
      }
    }

    function initMobile() {
      if (elZoom && pinchZoom) {
        return;
      }

      function setupPinchZoom() {
        if (typeof pinchZoom !== 'undefined') {
          return;
        }
        pinchZoom = new PinchZoom(elPinch, {
          tapZoomFactor: 3,
          zoomOutFactor: 3,
          animationDuration: 500,
          minZoom: 1,
          maxZoom: 3,
          draggableUnzoomed: true,
          setOffsetsOnce: true,
          lockDragAxis: false
        });
      }

      elPictureWrapper = document.createElement('div');
      elPictureWrapper.className = 'wb-picture-wrapper wb-video-wrapper';
      elPictureCanvas = document.createElement('canvas');
      elPictureCanvas.className = 'wb-picture__canvas';
      elPictureImgMaster = document.createElement('img');
      elPictureImgMaster.className = 'wb-picture__img ' + classMobileImg + ' ' + classMobileImgMaster;

      elPictureWrapper.appendChild(elPictureCanvas);
      elPinch.appendChild(elPictureWrapper);

      setupPinchZoom();

      // NOTE: Add <img> after initializing PinchZoom to prevent event listeners being added to them.
      elPictureWrapper.appendChild(elPictureImgMaster);

      resetZoom();

      elPictureImgMaster.addEventListener('load', function() {
        elPictureImgMaster.classList.add(classMasterShow);
      });
    }

    // `initialIndex` is the slide the overlay is being opened on. Building the swiper already
    // pointing at it, instead of creating it at slide 0 and sliding afterwards, means no
    // slideChange fires during the open — and that hook runs loadNextPrev, which requests the
    // previous slide's master alongside the one the shopper is waiting for. Left to the
    // lazyLoad plugin's own policy instead: it schedules the neighbours 100ms after the first
    // image has finished loading, so nothing competes with the active one.
    function initDesktop(clickEvent, initialIndex) {
      if (elZoom && elDesktopSwiper) {
        return;
      }

      var lastOffsetX;
      var lastOffsetY;

      function setInitialOffsets(clickEvent) {
        if (rectDesktopWrapper.left <= clickEvent.x && clickEvent.x <= rectDesktopWrapper.right) {
          lastOffsetX = clickEvent.x - rectDesktopWrapper.left;
          if (rectDesktopWrapper.top <= clickEvent.y && clickEvent.y <= rectDesktopWrapper.bottom) {
            lastOffsetY = clickEvent.y - rectDesktopWrapper.top;
          }
        }
      }

      function setupSwiper() {
        if (typeof elDesktopSwiper !== 'undefined') {
          return;
        }

        function getCoordinates(swiper, event) {
          if (event) {
            lastOffsetX = event.x - rectDesktopWrapper.left;
            lastOffsetY = event.y - rectDesktopWrapper.top;
          }
          var x = Math.min(Math.max((lastOffsetX / swiper.$(swiper.wrapperEl).outerWidth()) * 100, 0), 100);
          var y = Math.min(Math.max((lastOffsetY / swiper.$(swiper.wrapperEl).outerHeight()) * 100, 0), 100);
          return [x, y];
        }

        function onMouseLeave(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(225).transform('translate3d(0,0,0) scale(1)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
          if (event) {
            lastOffsetX = undefined;
            lastOffsetY = undefined;
          }
        }
        function onMouseMove(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          if (typeof lastOffsetX === 'undefined' || typeof lastOffsetY === 'undefined') { return; }
          if (desktopZoomHeldBy) { return; }
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            // Applies the scale here as well as in onMouseEnter, not just the origin. The
            // pointer is already inside the overlay when it opens — it is what was clicked —
            // so a zoom held back at mouseenter has no second enter event to arm it once the
            // master lands. The first mouse move after that is what turns it on.
            swiper.$(elZoom).transition(0).transform('translate3d(0,0,0) scale(2)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }
        function onMouseEnter(event) {
          var swiper = this;
          // Magnifying by 2 would take the interim render past its own resolution; the slide
          // stays at 1:1 until the master original has arrived (see showDesktopPreview).
          if (desktopZoomHeldBy) { return; }
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(0).transform('translate3d(0,0,0) scale(2)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }

        elDesktopSwiper = new Swiper('#' + idDesktopSwiper, {
          on: {
            init: function() {
              var swiper = this;
              swiper.$wrapperEl.each(function(elIndex, elWrapper) {
                elWrapper = swiper.$(elWrapper);
                elWrapper.on('mouseenter', onMouseEnter.bind(swiper), false);
                elWrapper.on('mousemove', onMouseMove.bind(swiper), false);
                elWrapper.on('mouseleave', onMouseLeave.bind(swiper), false);
              });
              swiper.$zoomEl = swiper.$wrapperEl.find('.' + classDesktopZoomContainer);
            },
            slideChange: function() {
              // The hold belongs to the slide the overlay opened on, which is the only one
              // given an interim render. Once the shopper has moved off it, whatever is on
              // screen is either its own finished master or nothing at all, and there is
              // no longer a lower-resolution frame that magnifying would expose.
              desktopZoomHeldBy = null;
            },
          },
          direction: 'vertical',
          slidesPerView: 1,
          spaceBetween: 10,
          initialSlide: initialIndex || 0,
          roundLengths: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: true
          },
          speed: 500,
          loop: false,
          autoplay: false,
          lazyLoad: {
            enabled: true,
            loadPrevNext: true
          },
          thumbs: {
            swiper: {
              el: '#product_zoom_desktop_swiper_thumbs',
              direction: 'vertical',
              slidesPerView: 6,
              spaceBetween: 5,
              roundLengths: false,
              mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
                invert: true
              },
              speed: 500,
              loop: false,
              autoplay: false,
              // This rail is the one that made the bare-`true` shorthand's failure visible:
              // every thumb in product-image-zoom.liquid is rendered with data-src and no
              // src, and nothing else picks them up — the page-level instance only watches
              // `.lazy`, and the main zoom swiper's instance is scoped to
              // '#product_zoom_desktop_swiper .slider-lazy', which this separate thumbs
              // container is not inside — so the whole rail sat blank next to a correctly
              // loaded main image. The plugin now coerces the boolean itself (global.js
              // beforeInit); the object form is kept here because it is the real shape.
              lazyLoad: { enabled: true }
            }
          }
        });
      }

      getRectDesktopWrapper();
      setupSwiper();

      if (clickEvent) {
        setInitialOffsets(clickEvent);
      }
    }

    function showMobile(srcEl) {
      if (!srcEl || !(Boolean(srcEl.dataset.zoomSrc) || srcEl.tagName === 'VIDEO')) {
        return;
      }
      //return on safari till update bug is fixed
      // if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
      //   return;
      // }

      initMobile();
   

      if (srcEl.tagName === 'VIDEO') { 
        elVideo = srcEl.cloneNode(true);

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elVideo, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.src = '';
      } else {
        elPictureImg = (srcEl.tagName === 'PICTURE' ? srcEl : srcEl.closest('picture')).cloneNode(true);
        elPictureImg.querySelector('img').className = 'wb-picture__img ' + classMobileImg;

        var srcMaster = srcEl.dataset.zoomSrc;

        if (!elPictureImg || !srcMaster) {
          return;
        }

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elPictureImg, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.src = srcMaster;
      }
    }

    function showDesktop(srcEl, clickEvent) {
      if (!srcEl || typeof srcEl.dataset.index === 'undefined') {
        return;
      }

      var index = parseInt(srcEl.dataset.index) || 0;

      setScrollbarAdjustments();

      // Before classShow, so the request for the interim render is already in flight when the
      // overlay is revealed rather than starting a frame later.
      showDesktopPreview(index);

      elZoom.classList.add(classShow);

      initDesktop(clickEvent, index);

      // A no-op on the open that just built the swiper — initialSlide put it here — and Swiper
      // returns without emitting slideChange when the index is unchanged. This is for the
      // reopen path, where initDesktop early-returns on the swiper it already has.
      elDesktopSwiper.slideTo(index, 0);
    }

    function show(srcEl, clickEvent) {
      if (!srcEl) {
        return;
      }

      if (!elZoom) {
        elZoom = document.getElementById(id);
        elButton = document.getElementById(idButtonClose);
        elMobile = document.getElementById(idMobile);
        elIcon = document.getElementById(idMobileIconWrapper);
        elPinch = document.getElementById(idMobilePinch);
        elButton.addEventListener('click', hide, { passive: true });

        document.body.appendChild(elZoom);

        document.addEventListener('WBContentLoaded', updateHTMLPosition, false);
        document.addEventListener('sweettooth-ready', updateHTMLPosition, false);

        if (isDesktop()) {
          window.addEventListener('resize', onResize.func, false);
        }
      }

      // Recorded here, at the one point the two halves diverge, so hide() can tear down the
      // half that was actually set up (see hide).
      openedDesktop = isDesktop();
      if (openedDesktop) {
        showDesktop(srcEl, clickEvent);
      } else {
        showMobile(srcEl);
      }

      hideSmile();
    }

    // Start the download for the frame the lightbox will open on, before it is clicked. Only
    // the overlay ever requests it, so without this the transfer begins at click time; a
    // pointer resting on the image is the earliest readable intent and typically buys the few
    // hundred milliseconds of travel before the click. The point is only to have the bytes in
    // the HTTP cache by the time showDesktopPreview asks for them.
    //
    // The interim render, not the master original. It is what governs how soon anything is on
    // screen, and it is a few hundred KB against the master's several MB — small enough to
    // spend on a hover that may come to nothing, which the master is not. The master still
    // starts at open, as it always has.
    //
    // Returns quietly on every miss: no such slide, a master already in the cache, a video, or
    // a viewport where the desktop overlay does not exist.
    function warm(srcEl) {
      if (!srcEl || typeof srcEl.dataset.index === 'undefined') {
        return;
      }
      // Same test isDesktop() makes, but resolving the element itself: warm runs on hover, so
      // it can be reached long before the first show() assigns elMobile.
      var mobileEl = elMobile || document.getElementById(idMobile);
      if (!mobileEl || window.getComputedStyle(mobileEl).display !== 'none') {
        return;
      }

      var slide = desktopSlideAt(parseInt(srcEl.dataset.index) || 0);
      var master = slide ? slide.querySelector(selectorDesktopMaster) : null;
      if (!master || (master.complete && master.naturalWidth > 0)) {
        return;
      }
      // data-src, not src: LazyLoad copies data-src onto src and leaves data-src in place, so
      // this is the url whether or not the slide has been opened before. The complete check
      // above is what rules out one already in the cache.
      var url = previewUrl(master.getAttribute('data-src'));
      if (!url || warmed[url]) {
        return;
      }
      warmed[url] = true;

      var image = new Image();
      // Chrome-only hint, ignored elsewhere. The shopper has not committed to opening the
      // zoom, so this must not outrank anything the page is still fetching for itself.
      if ('fetchPriority' in image) {
        image.fetchPriority = 'low';
      }
      image.src = url;
    }

    return {
      reset: reset,
      resetDesktop: resetDesktop,
      show: show,
      warm: warm
    };
  })();


  // What counts as the desktop zoom trigger, shared by the click below and the intent warm
  // under it so the two can never disagree about which elements open the lightbox.
  var ZOOM_TRIGGER_SELECTOR = '.wb-fashion__product-image-container .wb-picture__img, .wb-fashion__product-image-container .wb-video-wrapper video';

  // The leaf half of the selector above, checked before the ancestor walk. `pointerover`
  // fires for every element the pointer crosses on its way anywhere, and the warm listener
  // below runs on all of them — matches() against two bare tokens is far cheaper than
  // closest() against two descendant selectors, and neither an <img> nor a <video> has
  // rendered children, so a match can only ever be the target itself.
  var ZOOM_TRIGGER_LEAF_SELECTOR = '.wb-picture__img, video';

  function zoomTriggerFor(event) {
    var target = event.target;
    if (!target || !target.matches || !target.closest) {
      return null;
    }
    if (!target.matches(ZOOM_TRIGGER_LEAF_SELECTOR)) {
      return null;
    }
    return target.closest(ZOOM_TRIGGER_SELECTOR);
  }

  // Desktop click-to-zoom. There is no zoom icon on desktop — .wb-product-image-slider__zoom
  // lives in the mobile slider, which is visible-sm visible-xs — so the image itself is the
  // trigger, and showDesktop() reads its data-index to slide the pre-rendered #product_zoom
  // gallery to the right frame.
  //
  // Delegated on document rather than bound per image: the colour switch replaces the whole
  // desktop gallery (pdp-color-switch.js: swapDesktopImages), so a per-image listener would
  // only ever cover the colour the shopper landed on.
  document.addEventListener('click', function (event) {
    var elImage = zoomTriggerFor(event);
    if (!elImage) {
      return;
    }
    window.wbProductZoom.show(elImage, event);
  }, { passive: true });

  // Warm the zoom original once the pointer has settled on a gallery image (see
  // wbProductZoom.warm). Delegated for the same reason the click above is: the colour switch
  // replaces the whole desktop gallery, so a per-image listener would only ever cover the
  // colour the shopper landed on.
  //
  // Gated on dwell rather than fired on contact. These are unbounded master uploads and this
  // gallery is a tall column the pointer sweeps while the shopper scrolls, so warming on
  // contact would pull the entire set for someone who is only passing through. A single timer
  // means an image the pointer crosses on its way somewhere else never gets one.
  var ZOOM_WARM_DWELL_MS = 200;
  var zoomWarmTimer = null;

  function cancelZoomWarm() {
    if (zoomWarmTimer !== null) {
      clearTimeout(zoomWarmTimer);
      zoomWarmTimer = null;
    }
  }

  document.addEventListener('pointerover', function (event) {
    var elImage = zoomTriggerFor(event);
    cancelZoomWarm();
    if (!elImage) {
      return;
    }
    zoomWarmTimer = setTimeout(function () {
      zoomWarmTimer = null;
      window.wbProductZoom.warm(elImage);
    }, ZOOM_WARM_DWELL_MS);
  }, { passive: true });

  // A pointer that leaves the gallery entirely, and a tab that goes to the background before
  // the dwell elapses, are both "no longer intent".
  document.addEventListener('pointerout', function (event) {
    if (zoomTriggerFor(event)) {
      cancelZoomWarm();
    }
  }, { passive: true });
  document.addEventListener('visibilitychange', cancelZoomWarm, { passive: true });

  // Mobile zoom trigger — the expand icon over the image slider. One definition, exported,
  // because the icons do not survive a PDP colour switch: pdp-color-switch.js replaces the
  // whole slider markup and re-binds the icons it swapped in (swapMobileImages), and a second
  // copy of this over there is one that stops matching the moment the target selector changes.
  //
  // Which element to zoom is resolved at click time rather than captured per icon, so it
  // follows the active slide.
  function onMobileZoomIconClick() {
    var zoomTarget = document.querySelector('.fitness-info-flex .swiper-slide-active .wb-product__zoom, .product-image-slider-wrapper .swiper-slide-active .wb-product__zoom');

    if (zoomTarget) {
      window.wbProductZoom.show(zoomTarget);
    }
  }

  // `root` scopes the binding to freshly swapped-in markup; everything outside it keeps the
  // listener it was bound with at load. Defaults to the whole document for the initial pass.
  function bindMobileZoomIcons(root) {
    (root || document).querySelectorAll('.wb-product-image-slider__zoom').forEach(function (el) {
      el.addEventListener('click', onMobileZoomIconClick);
    });
  }

  window.wbBindMobileZoomIcons = bindMobileZoomIcons;

  // The one definition of the mobile image slider. Exported below because the PDP colour
  // switch tears these down and rebuilds them (pdp-color-switch.js: swapMobileImages), and a
  // second copy of this config over there drifted from this one the moment either was touched.
  function setupProductImageSlider(id) {
    var product_image_slider = document.getElementById(id);

    if (!product_image_slider || product_image_slider.className.indexOf('swiper-container-initialized') !== -1) {
      return;
    }

    bindMobileZoomIcons();

    var product_image_slider_thumbs = document.getElementById(id+'_thumbs');
    var thumbs = {};
    if (product_image_slider_thumbs) {
      var slidesperview = 4;
      // if(product_image_slider_thumbs.classList.contains('product_image_slider_mobile_thumbs-fashion')){
      //   var slidesperview = 6;
      // }
      thumbs.swiper = {
        el: product_image_slider_thumbs,
        navigation: {
          nextEl: '#' + product_image_slider_thumbs.id + ' + .wb-slider__nav2 .wb-slider__nav2-next',
          prevEl: '#' + product_image_slider_thumbs.id + ' + .wb-slider__nav2 .wb-slider__nav2-prev',
          disabledClass: 'wb-slider__nav2--disabled',
          hiddenClass: 'wb-slider__nav2--disabled'
        },
        slidesPerView: slidesperview,
        spaceBetween: 5,
        roundLengths: false,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          invert: true
        },
        // Object, not `true` — see the desktop zoom thumbs above. The thumbs past the fifth
        // are the ones rendered with data-src and no src, so they were what stayed blank.
        lazyLoad: { enabled: true }
      };
    }
    /// https://stackoverflow.com/questions/21377842/jquery-slider-move-nearest-slide-to-edge/21495762 fixes sticky slide after freemode slide
    return new Swiper(product_image_slider, {
      on: {
        // No `click` handler on purpose: tapping the image itself opened the lightbox until
        // b0d571a7b made the expand icon (bindMobileZoomIcons above) the only trigger.
        slideChange: function() {
          if (window.wbHeader && window.wbHeader.headroom && window.innerWidth < 1300) {
            window.wbHeader.headroom.unpin(500);
          }
        },
        touchEnd: function(event){
          //document.querySelector('html').style.overflowY = 'auto';
        },
        touchStart: function(event){
          //document.querySelector('html').style.overflowY = 'hidden';
        },
      },
      navigation: {
        nextEl: '#' + product_image_slider.id + ' .wb-product-image-slider__nav-next',
        prevEl: '#' + product_image_slider.id + ' .wb-product-image-slider__nav-prev',
        disabledClass: 'wb-product-image-slider__nav--disabled',
        hiddenClass: 'wb-product-image-slider__nav--disabled'
      },
      scrollbar: {
        el: '.wb-product-image-slider__scrollbar',
        // dragClass: 'wb-product-image-slider__scrollbar-drag',
        enabled: true,
        draggable: false,
        dragSize: 60,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      queueEndCallbacks: true,
      roundLengths: true,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      lazyLoad: {
        enabled: true,
        loadPrevNext: true
      },
      thumbs: thumbs,
    });
  }

  // Rebuild one of the two mobile sliders over freshly swapped-in markup. The colour switch
  // destroys the old instances, and wbProductSlider below holds them directly — so the new
  // instance has to be written back here or slideTo/changeFlavor keep addressing a destroyed
  // swiper for the rest of the page.
  window.wbSetupProductImageSlider = function (id) {
    var instance = setupProductImageSlider(id);
    if (!instance) {
      return instance;
    }
    if (id === 'product_image_slider_mobile') {
      swiper = instance;
    } else if (id === 'product_image_slider_mobile2') {
      swiper2 = instance;
    }
    return instance;
  };

  var swiper = setupProductImageSlider('product_image_slider_mobile');
  var swiper2 = setupProductImageSlider('product_image_slider_mobile2');

  window.wbProductSlider = {
    slideTo: function (index) {
      swiper.slideToLoop(index);
      swiper2?.slideToLoop(index);
    },
    changeFlavor: function (index) {
      if (typeof index === 'undefined') {
        return
      }
      var mobileSliderThumbsEl = document.getElementById('product_image_slider_mobile_thumbs');
      if (!mobileSliderThumbsEl) {
        return;
      }

      var lifestylePictureWrappersDesktop;
      var lifestylePictureWrappers;
      var lifestyleThumbsPictureWrappers;

      function queryLifestylePictureWrappers(elements) {
        if (!elements) { return [] }
        return Array.prototype.slice.call(elements).map(function (el) { return el.hasAttribute('data-index') ? el : el.querySelector('.wb-picture-wrapper[data-index]'); }).filter(function (el) { return parseInt(el.dataset.index) > 0; });
      }

      function ensureWrappersInititalized() {
        if (!lifestylePictureWrappersDesktop) {
          lifestylePictureWrappersDesktop = queryLifestylePictureWrappers(document.querySelector('.wb-single-product_product-image-previews-container').children);
        }
        if (!lifestylePictureWrappers) {
          lifestylePictureWrappers = queryLifestylePictureWrappers(document.querySelectorAll('#product_image_slider_mobile .swiper-slide, #product_image_slider_mobile2 .swiper-slide'));
        }
        if (!lifestyleThumbsPictureWrappers) {
          lifestyleThumbsPictureWrappers = queryLifestylePictureWrappers(document.querySelectorAll('#product_image_slider_mobile_thumbs .swiper-slide, #product_image_slider_mobile_thumbs2 .swiper-slide'));
        }
      }

      if (mobileSliderThumbsEl.dataset.flavorImages) {
        try {
          var flavorImages = JSON.parse(atob(mobileSliderThumbsEl.dataset.flavorImages)).splice(index * 4, 4);
          if (flavorImages && flavorImages.length >= 4) {
            ensureWrappersInititalized();
            flavorImages.forEach(function (image, index) {
              window.wbPicture.replaceSrc(lifestylePictureWrappersDesktop[index], image);
              window.wbPicture.replaceSrc(lifestylePictureWrappers[index], image);
              window.wbPicture.replaceSrc(lifestyleThumbsPictureWrappers[index], image);
            });
          }
        } catch (e) {
          console.log(e)
        }
      }

      if (mobileSliderThumbsEl.dataset.flavorLifestyleImages) {
        try {
          var flavorLifestyleImages = JSON.parse(atob(mobileSliderThumbsEl.dataset.flavorLifestyleImages));
          if (flavorLifestyleImages.length > index) {
            var lifestyleImage = flavorLifestyleImages[index].image;
            if (lifestyleImage) {
              ensureWrappersInititalized();
              window.wbPicture.replaceSrc(lifestylePictureWrappersDesktop[0], lifestyleImage);
              window.wbPicture.replaceSrc(lifestylePictureWrappers[0], lifestyleImage);
              window.wbPicture.replaceSrc(lifestyleThumbsPictureWrappers[0], lifestyleImage);
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
  };

  // fix safari scroll ux
  $('#product_image_slider_mobile,#product_image_slider_mobile2').scroll(function(event) {
    $(this).scrollLeft(0)
    $(this).css('overflow','hidden');
    swiper.slideTo(swiper.realIndex);
    swiper2?.slideTo(swiper.realIndex);
    setTimeout(function(){
      $(this).css('overflow','scroll hidden');
    },1);
  });

}, { passive: true });

document.addEventListener('DOMContentLoaded', function() {

  var productPage = document.querySelector('.wb-single-product');
  var isFashionSet = productPage && productPage.classList.contains('wb-fashion-set');


  var color_switch_sliderAll = document.querySelectorAll('.product-variants .fashion-color-switch');

  var color_switch_title = document.getElementById('fashion-color-switch-item-title');




if(isFashionSet){
color_switch_sliderAll.forEach(function(color_switch_slider){

  if (!color_switch_slider || color_switch_slider.className.indexOf('swiper-container-initialized') !== -1 || document.getElementById('fashion-color-switch')) {
    return;
  }
  /*
 var swiper = new Swiper(color_switch_slider, {
    on: {
      init: function() {
        */
        var classNoActive = 'wb-fashion-color-switch--noactive';
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.item a'));
        var current_title = color_items[0].getAttribute('title');
        var currentSetColor = current_title;

        function resetColorSwitchTitle() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }

        var resetColorSwitchTitleDebounced = debounce(resetColorSwitchTitle, 225);


          color_items.forEach(function(el){

            el.addEventListener('click', function() {
              currentSetColor = el.getAttribute('title');
              color_switch_title.innerText = currentSetColor;
              console.log('click',el.getAttribute('title'));
              $('[data-color="'+decodeURIComponent(el.getAttribute('title')).replace(/\+/g, ' ')+'"]').trigger('click');
            });

            el.addEventListener('mouseenter', function() {
              color_switch_title.innerText = el.getAttribute('title');
            });

          });
          color_switch_slider.addEventListener('mouseleave', function() {
            color_switch_title.innerText = currentSetColor;
          });
/*
      }
    },
    navigation: {
      nextEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-next',
      prevEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-prev',
      disabledClass: 'wb-fashion-color-switch__nav--disabled',
      hiddenClass: 'wb-fashion-color-switch__nav--disabled'
    },
    slidesPerView: 'auto',
    spaceBetween: 5,
    roundLengths: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    speed: 500,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true
  });
*/
});

  return;
}

  var color_switch_slider = document.getElementById('fashion-color-switch');
 if (!color_switch_slider || color_switch_slider.className.indexOf('swiper-container-initialized') !== -1 || document.getElementById('fashion-color-switch')) {
    return;
  }
 /*
  var swiper = new Swiper(color_switch_slider, {
    on: {
      init: function() {
        var swiper = this;
        if (swiper.slides.length <= 1) {
        */
        var items = color_switch_slider.querySelectorAll('.item');
        if (items.length <= 1) {
          var wrapperEl = color_switch_slider.closest('.product-variants');
          if (wrapperEl && wrapperEl.childElementCount === 1) {
            if(window.location.pathname.indexOf('eco-bottle-white') === -1 && window.location.pathname.indexOf('hot-cold-bottle') === -1){
            wrapperEl.style.display = 'none';
            }
          }
        }

        var classNoActive = 'wb-fashion-color-switch--noactive';
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.item a, a.item'));
        var current_title = color_items[0].getAttribute('title');

        function resetColorSwitchTitle() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }

        var resetColorSwitchTitleDebounced = debounce(resetColorSwitchTitle, 225);

        color_items[0].addEventListener('mouseenter', function() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }, { passive: true });
        color_items.slice(1).forEach(function(el) {
          el.addEventListener('mouseenter', function() {
            resetColorSwitchTitleDebounced.cancel();
            color_switch_slider.classList.add(classNoActive);
            color_switch_title.innerText = el.getAttribute('title');
          }, { passive: true });
          el.addEventListener('mouseleave', resetColorSwitchTitleDebounced.func);
        });
        color_switch_slider.addEventListener('mouseleave', resetColorSwitchTitle, { passive: true });
        /*
      }
    },
    navigation: {
      nextEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-next',
      prevEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-prev',
      disabledClass: 'wb-fashion-color-switch__nav--disabled',
      hiddenClass: 'wb-fashion-color-switch__nav--disabled'
    },
    slidesPerView: 'auto',
    spaceBetween: 5,
    roundLengths: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    speed: 500,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true
  });
*/


}, { passive: true });




document.addEventListener('DOMContentLoaded', function () {

  window.changeVariantImages = function changeVariantImages(variant) {
    var flavorId = variant.getAttribute('data-flavor');
    var imgSrc = variant.getAttribute('data-img-src');

    Array.prototype.slice.call(document.querySelectorAll('.fitness-info-flex [data-flavors]')).forEach(function (element) {
      if (flavorId && imgSrc && element && (element.getAttribute('data-flavors') || '').split(/,/).indexOf(flavorId) !== -1) {
         window.wbPicture.replaceSrc(element, imgSrc, { crop: 'bottom' });
      }
    });

    if (window.wbProductSlider.changeFlavor && variant.dataset.index) {
      window.wbProductSlider.changeFlavor(variant.dataset.index);
    }

    if (window.shakerInfoImages) {
      var variantName = (variant.innerText || '').trim().toLowerCase();
      var colorImages = window.shakerInfoImages[variantName] || {};
      var defaultImages = window.shakerInfoImages['_default'] || {};

      [3, 4].forEach(function (i) {
        var el = document.getElementById('shaker-info-' + i);
        if (el) {
          var newSrc = colorImages['info' + i] || defaultImages['info' + i];
          if (newSrc) {
            var imgWrapper = el.querySelector('.product-info-banner__image .wb-picture-wrapper');
            if (imgWrapper) {
              window.wbPicture.replaceSrc(imgWrapper, newSrc, { crop: 'bottom' });
            }
          }
        }
      });

      var bannerSrc = colorImages.banner || defaultImages.banner;
      if (bannerSrc) {
        var bannerEl = document.querySelector('.product-quote-banner .product-quote-banner__image');
        if (bannerEl) {
          window.wbPicture.replaceSrc(bannerEl, bannerSrc, { crop: 'bottom' });
        }
      }
    }

  }

  // Serving source of the variant the label currently shows. Starts as the
  // server-rendered (default selected) option so a change to a variant with the
  // same serving text is a no-op and keeps any per-shop copy override intact
  // (see snippets/product-servings.liquid, FR block).
  var currentServingSource;

  function getServingSource(variant) {
    var servingSize = variant.getAttribute('data-serving-size') || '';
    var optionText = (variant.textContent || '').trim();
    // Mirrors product-servings.liquid: capsule products keep the servings in
    // option1 ("120 Capsules (30 Servings)"), powders in option2.
    if (optionText.indexOf('(') !== -1) {
      return optionText;
    }
    return servingSize;
  }

  window.changeVariantSize = function changeVariantSize(variant) {
    // product-info-badges.liquid reuses .product-servings__label for the
    // "Made in Germany" / "Vegan" badges; only the real servings label counts.
    var sizeLabel = Array.prototype.filter.call(document.querySelectorAll('.product-servings__label'), function (label) {
      return !label.closest('.product-info-badges');
    })[0];
    if (!sizeLabel || !variant) {
      return;
    }

    var newSource = getServingSource(variant);
    if (!newSource) {
      return;
    }

    if (currentServingSource === undefined) {
      var select = variant.closest ? variant.closest('select') : null;
      var initialOption = null;
      if (select) {
        initialOption = Array.prototype.filter.call(select.options, function (option) {
          return option.defaultSelected;
        })[0] || select.options[0];
      }
      currentServingSource = initialOption ? getServingSource(initialOption) : '';
    }

    if (newSource === currentServingSource) {
      return;
    }
    currentServingSource = newSource;

    // Same output as the Liquid render: "204 g | 7.2 oz (40 Servings)"
    // -> "204 g | 7.2 oz<br>40 Servings". A label rendered without <br>
    // (generic product types) shows the raw option text.
    if (!sizeLabel.querySelector('br')) {
      sizeLabel.textContent = newSource;
      return;
    }

    var parts = newSource.split('(');
    var firstPart = parts[0].trim();
    var secondPart = (parts[1] || '').replace(/\)/g, '').trim();
    // "26.5 ml (0.90 fl oz) (90 Servings)" keeps the bracketed unit on the
    // first line, like the single-option branch of product-servings.liquid.
    if (parts.length === 3) {
      firstPart = (parts[0] + '(' + parts[1]).trim();
      secondPart = parts[2].replace(/\)/g, '').trim();
    }

    while (sizeLabel.firstChild) {
      sizeLabel.removeChild(sizeLabel.firstChild);
    }
    sizeLabel.appendChild(document.createTextNode(firstPart));
    sizeLabel.appendChild(document.createElement('br'));
    sizeLabel.appendChild(document.createTextNode(secondPart));
  }


  // function which takes the current clicked variant as input, gets the price and updates it on the website
  window.changeVariantPrice = function changeVariantPrice(selectedOptions) {
    var options = document.querySelectorAll('option');
    var currentPrice = document.querySelector('.product-price__price');
    var currentPriceCompare = document.querySelector('.product-price__price-compare');
    var currentPriceOff = document.querySelector('.product-price__savings');
    var newPrice;
    var newPriceCompare;
    var newPriceOff;



    for(var i=0; i < options.length; i++){
      if(options[i].dataset.price == undefined){
        return;
      }
      if(selectedOptions.dataset.sku == options[i].dataset.sku){
        newPrice = options[i].dataset.price;
        newPriceCompare = options[i].dataset.priceCompare;
        newPriceOff = options[i].dataset.priceOff;
      }
    }


    if(currentPrice.innerText != newPrice && newPrice !== undefined){
      currentPrice.innerText = newPrice;
      currentPriceCompare.innerText = newPriceCompare;
      currentPriceOff.innerText = newPriceOff;
    }

  }

  window.changeVariantContents = function changeVariantContents(variant) {
    var sku = variant.getAttribute('data-sku');
    if (!sku) {
      return;
    }
    sku = sku.replace(/^OF/, '');
    function updateContentSku(parent) {
      if (!parent) {
        parent = document;
      }
      Array.prototype.slice.call(parent.querySelectorAll('[data-content-sku]')).forEach(function (element) {
        if ((element.getAttribute('data-content-sku') || '').split(/,/).map(function (sku) { return sku.replace(/^OF/, ''); }).indexOf(sku) === -1) {
          element.style.display = 'none';
        } else {
          element.style.display = '';
        }
      });
    }
    var bundleProperties = (variant.getAttribute('value') || '').split(/,/);
    if (bundleProperties.length > 1 && bundleProperties[1]) {
      var elements = Array.prototype.slice.call(document.querySelectorAll('[data-content-handle]')).filter(function (element) {
        return (element.getAttribute('data-content-handle') || '').split(/,/).indexOf(bundleProperties[1]) !== -1;
      });
      elements.forEach(updateContentSku);
    } else {
      updateContentSku();
    }
  }

  window.handleVariantUrl = function handleVariantUrl(variant) {
    if (!variant || !variant.dataset.url) {
      return;
    }
    var newUrl = window.location.origin + variant.dataset.url;
    if (newUrl == window.location.href) {
      return;
    }
    window.location.href = newUrl;
  }

  function setupFlavorButtons() {
    Array.prototype.slice.call(document.querySelectorAll('.product-flavors-container')).forEach(function (element) {
      var title = element.querySelector('.product-flavors-title__variant');
      var list = element.querySelector('.product-flavors');
      var size = document.querySelectorAll('.variant-col-input .product-flavors-title__variant')[0];

      if (!title || !list) {
        return;
      }

      function handleFlavorChange(flavors, flavor, event) {
        if (flavor.classList.contains('disabled') || flavor.hasAttribute('disabled')) {
          return;
        }

        flavors.forEach(function (flavor) {
          flavor.classList.remove('active');
        });
        flavor.classList.add('active');
        list.classList.remove('red');
        title.innerText = flavor.innerText;
        if(flavor.getAttribute("data-serving-size") != '' && size != undefined){
          size.textContent = flavor.getAttribute("data-serving-size");
        }
        window.changeVariantImages(flavor);
        window.changeVariantContents(flavor);
        window.handleVariantUrl(flavor);
        window.changeVariantPrice(flavor);
      }

      var flavors = Array.prototype.slice.call(list.querySelectorAll('li'));
      flavors.forEach(function (flavor) {
        flavor.addEventListener('click', handleFlavorChange.bind(null, flavors, flavor));
        flavor.addEventListener('mouseenter', function () {
          title.innerText = flavor.innerText;
        });
        flavor.addEventListener('mouseleave', function () {
          flavors.forEach(function (flavor) {
            if (!flavor.classList.contains('active')) {
              return;
            }
            title.innerText = flavor.innerText;
          });
        });
      });
    });
  }

  function setupQuantityInput() {
    Array.prototype.slice.call(document.querySelectorAll('.wb-quantity-input')).forEach(function (element) {
      var input = element.querySelector('input');
      var decButton = element.querySelector('button[data-quantity-dec]');
      var incButton = element.querySelector('button[data-quantity-inc]');
      if (!input || !decButton || !incButton) {
        return;
      }
      var minValue = input.hasAttribute('min') ? Number(input.getAttribute('min')) : 1;
      var maxValue = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Number.MAX_SAFE_INTEGER;
      decButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.max(minValue, Number(input.value) - 1);
      });
      incButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.min(maxValue, Number(input.value) + 1);
      });
    });
  }

  setupFlavorButtons();
  setupQuantityInput();

}, { passive: true });

jQuery(document).ready( function($) {
  function setupReadMore() {
    var showChar = 480;
    var ellipsestext = "";
    var moretext = "... Show more";
    var lesstext = "Show less";
    var counter = 1;
    var t = 200,linear;
    var lang = document.documentElement.lang.split(/-/)[0];
    switch (lang) {
      case "de":
        moretext = "... mehr";
        lesstext = "weniger";
        break;
      case "fr":
        moretext = "... Voir plus";
        lesstext = "Voir moins";
        break;
      case "es":
        moretext = "... Ver más";
        lesstext = "Ver menos";
        break;
    }
    $('.more p').first().addClass('first-p');
    $('.more').each(function(index) {
      var content = $(this).html();
      var textLength = $(this).text();
      var moreElement = $(this);
      //console.log(index)


      var c = content.substr(0, showChar);

      var h = content.substr(showChar, content.length);


      var l = c.length + h.indexOf('.')+1;

      c = content.substr(0,l);

      h = content.substr(l, content.length);




      // console.log(c,h);


      //console.log(content.length,l,h.length)


      //console.log('c:'+ c);
      //console.log('h:'+ h);


      if(content.length > l && h.length > 50) {

        $(this).addClass('add-more-setup');

        //console.log('c:'+ c);
        //console.log('h:'+ h);

        //var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        $(this).html(html);
      }




      if($('.morelink'+index).is(':visible')){
      }else {
        $('.first-'+index+' p:nth-child(2)').show();
        $('.morecontent'+index).hide();
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(3)').show();
          $('.morecontent'+index).hide();

        }
      }
      $(".morelink"+index).click(function(){
        $('.more-'+index+' .last').show(t);
        $('.more-'+index+' .first').hide(t);
        $(this).addClass("less");
        $('.morelink'+index).html(lesstext);
        $('.more'+index+' .first-p span').show(t);
        $('.more-'+index+' p').show(t);
        $('.more-'+index+' .first-p span').show(t);
        $('.morecontent'+index).show(t);

      });
      $(".lesslink"+index).click(function(){
        $('.more-'+index+' .first').show(0);
        $('.more-'+index+' .last').hide(0);
        $(this).removeClass("less");
        $('.more-'+index+' p').hide(0);
        $('.morecontent'+index).hide(0);
        $('.more-'+index+'first-p').css('display','bock!important');
        $(".more-"+index+" .first-p:not('.morecontent')").show(0);
        $('.more-'+index+' .first-p span').hide(0);
        $('.morelink'+index).html(moretext);
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(2)').show();
          $('.morecontent'+index).hide();
          if($('.morelink'+index).is(':visible')){
          }else {
            $('.first-'+index+' p:nth-child(3)').show();
            $('.morecontent'+index).hide();
          }
        }
        return false;
      });
    });
  }

  // Remove title class from content box
  $('.tab-content p').removeClass('product__bundle-title');

  //
  //
  // Default variant select
  //
  //
  var variantDefaultValue = $('.wb-product_native-variants span:first');

  $(".wb-fashion-variants").on('change', function() {
    if($(this).val()!=="") {
      $('.wb-product-addtocart-btn').css('cursor','pointer');
      $('.wb-product-addtocart-btn').removeClass('disabled');
      $('.wb-product-addtocart-btn').prop('disabled', false);
      $('.ajaxified-cart-feedback').hide();
      $('.wb-variant-select').css('border','none');
    }
  });

  $(".wb-fashion-variants").on('click', function(e){
    e.preventdefault;

    if ($(".wb-fashion-variants").hasClass('disabled')){
      //console.log('test');
    }
  });

  //
  //
  // Free shipping on Product Page
  //
  //

  var shippingText = $('.wb-header_shipping-text').first().text();
  $('#pp_shipping-text').html(shippingText);

  //
  //
  // QTY INPUT
  // Neues ProductPage Screendesign Aug2017
  //
  var $qtyInputGroup = $('.wb-qty-input');
  var $qtyDecButton = $qtyInputGroup.find('.btn-dec');
  var $qtyIncButton = $qtyInputGroup.find('.btn-inc');
  var $qtyInput = $qtyInputGroup.find('.qty-input');
  var maxqty = 50;
  $qtyIncButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    $qtyInput.val( val + 1);
    if($qtyInput.val() >maxqty){
      $qtyInput.val( maxqty );
    }
  });

  $qtyDecButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    if( val > 1){
      $qtyInput.val( val - 1);
    }
  });

  $qtyInput.on('change', function(e) {
    if( $qtyInput.val() > maxqty){
      $qtyInput.val( maxqty );
    }
  });


  var $variant_select = $('.wb-product-variants');

  $variant_select.selectpicker({
    style: 'wb-variant-select btn-lg',
    dropupAuto: false
  });
  $variant_select.selectpicker('refresh');
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|WomensBestApp/i.test(navigator.userAgent) ) {
    $variant_select.selectpicker('mobile');
  }

  $(".wb-product-variants > option").each(function() {
    var status = $(this).data('available');
    if(status == 'false'){
      var index =  $(this).index();
      $('.wb-product-variants .dropdown-menu').find("[data-original-index='" + index + "']").addClass('disabled');
    }
  });

  function setupVariantDropdowns() {
    var variantDropdowns = Array.prototype.slice.call(document.querySelectorAll('#add-to-cart-form select.wb-product-variants'));

    function updateVariantPriceInfo(selectedOption) {
      var priceInfo = document.querySelector('.wb-single-product_meta-container [data-price-info-target]');
      if (!priceInfo) {
        return;
      }
      var priceInfoLabel = priceInfo.dataset.priceInfoLabel;
      if (!priceInfoLabel) {
        return;
      }
      var size = selectedOption.dataset.servingSize;
      if (!size) {
        return;
      }
      var price = parseInt(selectedOption.dataset.priceCents);
      if (isNaN(price) || !price) {
        return;
      }

      var match = size.match(/^(\d+)\s?x/);
      if (!match || match.length < 2) {
        return;
      }
      var servingQuantity = parseInt(match[1] || 0);
      if (isNaN(servingQuantity) || servingQuantity < 1) {
        return;
      }
      var servingPrice = parseInt(price / servingQuantity);
      if (!Shopify.formatMoney) {
        return;
      }
      priceInfo.innerHTML = Shopify.formatMoney(servingPrice) + ' / ' + priceInfoLabel;
    }

    function updateVariantPrice(selectedOption) {
      var priceCompareTarget = $('.wb-single-product_meta-container [data-price-compare-target]');
      var priceOffTarget = $('.wb-single-product_meta-container [data-price-off-target]');
      var priceTarget = $('.wb-single-product_meta-container [data-price-target]');

      var priceCompare = selectedOption.dataset.priceCompare;
      var hasCompare = (priceCompare || '').length > 0;
      if (typeof priceCompare !== 'undefined') {
        priceCompareTarget.html(priceCompare);
      }
      priceCompareTarget.css('display', hasCompare ? '' : 'none');

      var priceOff = selectedOption.dataset.priceOff;
      if (priceOff !== 'undefined') {
        priceOffTarget.html(priceOff);
      }
      priceOffTarget.css('display', hasCompare ? '' : 'none');

      var price = selectedOption.dataset.price;
      if (typeof price !== 'undefined') {
        priceTarget.html(price);
      }
      if (hasCompare) {
        priceTarget.addClass('product-price__price--has-compare');
      } else {
        priceTarget.removeClass('product-price__price--has-compare');
      }

      updateVariantPriceInfo(selectedOption);

      if (typeof window.updatePPBestPoints !== 'undefined') {
        var priceCents = selectedOption.dataset.priceCents;
        if (typeof priceCents !== 'undefined') {
          window.updatePPBestPoints(priceCents);
        }
      }
    }




    function handleVariantChange(e) {
      var selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) {
        return;
      }


      window.wbProductSlider.slideTo(0);
      window.changeVariantImages(selectedOption);
      window.changeVariantContents(selectedOption);
      window.changeVariantSize(selectedOption);
      window.changeVariantPrice(selectedOption);
      updateVariantPriceInfo(selectedOption);
      //updateVariantPrice(selectedOption);
      if (typeof e !== 'undefined') {
        window.handleVariantUrl(selectedOption);
      }
    }

    variantDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', handleVariantChange, { passive: true });
      dropdown.addEventListener('change', function (event) {
        var $this = $(event.target.options[event.target.selectedIndex]);
        document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { nutrition: true, sku: $this.data('sku'), id: $this.data('flavor') } }));
      }, false);
      handleVariantChange.call(dropdown);
    });
  }

  setupVariantDropdowns();



  setupReadMore();

});


document.addEventListener('DOMContentLoaded', function () {


  function updateProductPrice(options) {
    const {
      variant_price,
      variant_compareprice,
      currentLang,
      currentShop ,
    } = options;
    
    function formatMoney(price) {
      return Shopify.formatMoney(price);
    }
    
    function getLanguageText() {
      const texts = {
        savingsText: {
          'de': `-{AMOUNT}%`,
          'fr': `-{AMOUNT}%`,
          'es': `-{AMOUNT}%`,
          'en': `{AMOUNT}% OFF`
        },
        priceLabel: {
          'de': 'Preis:',
          'fr': 'Prix:',
          'es': 'Precio:',
          'en': 'Price:'
        }
      };
      return texts;
    }
    let texts = getLanguageText()
    // for return
    const priceContainer = document.querySelector('.product-price');
    if (!priceContainer) return;
    

    // savings
    const savingsElement = document.querySelector('.product-price__savings');
    if (savingsElement) {
      if (variant_compareprice > variant_price) {
        const savingsPercent = Math.round((variant_compareprice - variant_price) * 100.0 / variant_compareprice);
        const savingsText = texts.savingsText[currentLang] || texts.savingsText['en'];
        savingsElement.innerHTML = savingsText.replace('{AMOUNT}', `<span>${savingsPercent}</span>`);
        savingsElement.style.display = '';
      } else {
        savingsElement.style.display = 'none';
      }
    }

    // compare price
    const comparePriceElement = document.querySelector('.product-price__price-compare');
    if (comparePriceElement) {
      if (variant_compareprice > variant_price) {
        const formattedComparePrice = formatMoney(variant_compareprice);

        comparePriceElement.innerHTML = formattedComparePrice;
        comparePriceElement.dataset.priceCompare = variant_compareprice;
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }

    // current price
    const priceElement = document.querySelector('.product-price__price');
    if (priceElement) {
      const formattedPrice = formatMoney(variant_price);

      priceElement.innerHTML = formattedPrice;
      priceElement.dataset.price = variant_price;
      priceElement.classList.remove('product-price__price--has-compare');
      if (variant_compareprice > variant_price) {
        priceElement.classList.add('product-price__price--has-compare');
      } else {

      }
    }

  }

  // Exposed for callers outside this scope. assets/pdp-color-switch.js re-binds the size
  // handlers after a colour switch and needs the same price update the on-load handler does;
  // without this it carried a second implementation that had to track money_format and the
  // localised savings string on its own, and got both wrong.
  window.wbUpdateProductPrice = function (variantPrice, variantComparePrice) {
    updateProductPrice({
      variant_price: variantPrice,
      variant_compareprice: variantComparePrice,
      currentLang: document.documentElement.lang.split(/-/)[0],
      currentShop: typeof currentShop !== 'undefined' ? currentShop : '',
    });
  };
  


  function setupFashionView() {
    //Size SELECT
    var $input = $('#variant-id');
    var $addToCartBtn = $('.wb-product-addtocart-btn');
    var $sizeBtnsWrapper = $('.fashion-info-sticky ul.product-sizes');

    $('.wb-product-addtocart-btn:not(.wb-product-addtocart-btn-cts, .product-stl__submit-button)').on('click', function(event){
      if ($('.wb-product-addtocart-btn').hasClass('early-access-cta')) {
        //
      } else {
        if ($input.val() == ''){
          event.preventDefault();
          $('.product-sizes:not(.product-sizes-cts, .product-stl-sizes)').addClass('red');
          $('.choose-size-alert').show(100);
          $('.product-add-to-cart.is-sticky:not(.product-add-to-cart-cts)').addClass('product-add-to-cart-error');
        }
      }
    });

    $sizeBtnsWrapper.each(function(){
      var $sizeBtns = $(this).find('li');

      $sizeBtns.each(function(i) {
        var $this = $(this);
        // a11y: Enter/Space activation for these <li role="button"> options is
        // delegated once in snippets/a11y-interactive.liquid, so that the size
        // lists rendered outside this wrapper (complete-the-set modal, and any
        // list inserted after load) get it too. Do not re-bind keydown here —
        // two handlers would each fire click and toggle the size twice.
        $this.on('click', function(e) {
       
          var $this = $(this);
          var variant_id = $(this).data('size');
          var variant_sku = $(this).data('sku');
          var variant_price = $(this).data('price');
          var variant_compareprice = $(this).data('compareprice');
       
          if (! $this.hasClass('disabled')) {
            //Classes
            $sizeBtns.removeClass('active');
            $this.addClass('active');
            // a11y: reflect the chosen size to screen readers
            $sizeBtns.attr('aria-pressed', 'false');
            $this.attr('aria-pressed', 'true');

            $('.product-sizes').removeClass('red');

            $('.choose-size-alert').hide(100);
            $('.product-add-to-cart.is-sticky').removeClass('product-add-to-cart-error');

            if($(this).data('set')){
              return;
            }

            if (variant_id) {
              $addToCartBtn.attr("disabled", false);
              if($input.hasClass('fashion-set')){}else{
                $input.val(variant_id);
                $input.attr('data-sku',variant_sku);
              }
              // $('#wb-fashion .fashion-info-flex #in-den-warenkorb').css('background','#ffb00d');
              $('#wb-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');

              document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { sportswear: true, sku: $this.data('sku'), id: $this.data('size'), name: $this.data('title') } }));
              //console.log("variant_price 0 ",variant_price)
              if(variant_price && variant_compareprice){
             //   console.log("variant_price 1 ",variant_price)
                updateProductPrice({
                  variant_price: variant_price,
                  variant_compareprice: variant_compareprice,
                  currentLang: document.documentElement.lang.split(/-/)[0],
                  currentShop: currentShop,
                });
                
              }
            } else {
              $addToCartBtn.attr("disabled", true);

            }
          }
        });
      });
    });

    $('.is-sticky #in-den-warenkorb.select').on('click', function(){
      if (!$(this).hasClass('select')) {
        return;
      }
      if(isMobile()){
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".fashion-info-flex").offset().top-100
        }, 500);
      }
    });
  }

  


  function setupFitnessView() {
    //Flavor SELECT
    var $input = $('#flavor-id');
    var $addToCartBtn = $('.wb-product-addtocart-btn');
    var $flavorBtns = $('.fitness-info-sticky ul.product-flavors li');
    var variantTitle = $('.product-flavors-title__variant').first();
    var $productPrice = $('.product-price__price');
    var $productPriceCompare = $('.product-price__price-compare');
    var $productPriceSavings = $('.product-price__savings span');


    $flavorBtns.each(function(i) {
      var $this = $(this);

      $this.on('click', function(e) {
        var $this = $(this);
        var variant_id = $(this).data('flavor');
        var variant_sku = $(this).data('sku');
        var variant_price = $(this).data('price');
        var variant_price_cents = $(this).data('price-cents');
        var variant_compprice = $(this).data('price-compare');
        var variant_compprice_cents = parseInt((($(this).data('price-compare') || '').match(/\d+/g) || []).join('')) || '';


        if(variant_price != $productPrice.text() && $productPrice.length > 0 ){  // update price
          $productPrice.html(variant_price);
          $productPrice.attr('data-price',variant_price_cents);
          if($productPriceCompare.length > 0 && $productPriceSavings.length > 0){
            $productPriceCompare.html(variant_compprice);
            $productPriceCompare.attr('data-price-compare',variant_compprice_cents);
            if (variant_compprice_cents) {
              var variant_savings = Math.round((1-(variant_price_cents / variant_compprice_cents))*100);
              $productPriceSavings.html(variant_savings);
              $productPrice.addClass('product-price__price--has-compare');
              $('.product-price__savings').show();
            } else {
              $productPrice.removeClass('product-price__price--has-compare');
              $('.product-price__savings').hide();
              $productPriceSavings.html('');
            }
          }
          //$('.wb-smile-pp-value').html(variant_price_cents)

          if (typeof window.updatePPBestPoints !== 'undefined') {
            window.updatePPBestPoints(variant_price_cents);
          }
        }

        if (! $this.hasClass('disabled')) {
          //$('.choose-flavor-alert').hide(100);
          if (variant_id) {
            $addToCartBtn.attr("disabled", false);
            $input.val(variant_id);
            $input.attr('data-sku',variant_sku);
            // $('.fitness-info-flex #in-den-warenkorb').css('background','#ffb00d');
            // $('.fitness-info-flex #in-den-warenkorb').removeClass('select');

            document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { nutrition: true, sku: $this.data('sku'), id: $this.data('flavor') } }));
          } else {
            $addToCartBtn.attr("disabled", true);
          }
        }
      });
    });
    // update price mobile
    $input.change(function(){
      var variant_price = $(this).find(':selected').attr('data-price')
      var variant_price_cents = $(this).find(':selected').attr('data-price-cents');
      var variant_compprice = $(this).find(':selected').attr('data-price-compare');
      var variant_compprice_cents = parseInt((($(this).find(':selected').attr('data-price-compare') || '').match(/\d+/g) || []).join(''));

      if($(this).find(':selected').attr('data-price') != $productPrice.text() && $productPrice.length > 0 ){
        $productPrice.html(variant_price);
        $productPrice.attr('data-price',variant_price_cents);
        if($productPriceCompare.length > 0 && $productPriceSavings.length > 0){
          $productPriceCompare.html(variant_compprice);
          $productPriceCompare.attr('data-price-compare',variant_compprice_cents);
          if (variant_compprice_cents) {
            var variant_savings = Math.round((1-(variant_price_cents / variant_compprice_cents))*100);
            $productPriceSavings.html(variant_savings);
            $productPrice.addClass('product-price__price--has-compare');
            $('.product-price__savings').show();
          } else {
            $productPrice.removeClass('product-price__price--has-compare');
            $('.product-price__savings').hide();
            $productPriceSavings.html('');
          }
        }

        if (typeof window.updatePPBestPoints !== 'undefined') {
          window.updatePPBestPoints(variant_price_cents);
        }

      }
    });


     function selectFlavorViaName() {

      function findGetParameter(parameterName) {
        var result = null,
          tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        console.log('f result', result);
        return result;
      }

      var selectedName = findGetParameter('flavourName');

      if (document.querySelector('.fitness-info-flex') !== null && typeof selectedName !== undefined && selectedName && selectedName.length > 0) {
        var option = document.querySelector('#add-to-cart-form #flavor-id option[data-variant-name="' + selectedName + '"]');
        if (!option) {
          return;
        }
        if (option.hasAttribute('disabled')) {
          return;
        }
        var variantId = $(option).val();
        if (!variantId) {
          return;
        }
        setTimeout(function () {
          $(document.querySelector('#add-to-cart-form .product-flavors li[data-variant-name="' + selectedName + '"]')).trigger('click');
        }, 1000);
        $(document.querySelector('#add-to-cart-form select[name*="id"]')).val(variantId).selectpicker('refresh');
      }
    }

    function selectFlavorViaSkuParameter() {
      function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
      }

      var selectedSku = findGetParameter('sku');

      if (document.querySelector('.fitness-info-flex') !== null && typeof selectedSku !== undefined && selectedSku && selectedSku.length > 0) {
        var option = document.querySelector('#add-to-cart-form #flavor-id option[data-sku="' + selectedSku + '"]');
        if (!option) {
          return;
        }
        if (option.hasAttribute('disabled')) {
          return;
        }
        var variantId = $(option).val();
        if (!variantId) {
          return;
        }
        setTimeout(function () {
          $(document.querySelector('#add-to-cart-form .product-flavors li[data-sku="' + selectedSku + '"]')).trigger('click');
        }, 1000);
        $(document.querySelector('#add-to-cart-form select[name*="id"]')).val(variantId).selectpicker('refresh');
      }
    }

    function setupProductLaunchVideoModal() {
      var modals = Array.prototype.slice.call(document.querySelectorAll('.product-launch-info__video-modal'));
      modals.forEach(function (modal) {
        var $modal = $(modal);
        var video = modal.querySelector('video');
        $modal.on('hide.bs.modal', function () {
          if (video) {
            try {
              video.pause();
            } catch (e) {
              //
            }
          }
        });
      });
      var isBundle = document.getElementById('product-sections') != null;
      if (!isBundle) {
        return;
      }
      var main = document.querySelector('main');
      if (!main) {
        return;
      }
      modals.forEach(function (modal) {
        main.appendChild(modal);
      });
    }

    selectFlavorViaName();
    selectFlavorViaSkuParameter();
    setupProductLaunchVideoModal();
  }

  setupFashionView();
  setupFitnessView();

}, { passive: true });

document.addEventListener('DOMContentLoaded', function () {
  var $$ = window.Swiper.$;

  function setupTabs() {
    var desktopTabs = Array.prototype.slice.call(document.querySelectorAll('.desktop-tab'));
    desktopTabs.forEach(function(desktopTab) {
      var tabHeadlines = Array.prototype.slice.call(desktopTab.querySelectorAll('.desktop-tab-headline[data-tab]'));
      tabHeadlines.forEach(function(tabHeadline) {
        tabHeadline.addEventListener('click', function (event) {
          var tabId = tabHeadline.getAttribute('data-tab');
          var tabContent = tabHeadline.nextElementSibling.classList.contains('desktop-tab-content') && tabHeadline.nextElementSibling.getAttribute('data-tab-content') === tabId ? tabHeadline.nextElementSibling : desktopTab.querySelector('.desktop-tab-content[data-tab-content="' + tabId + '"]');
          if (!tabContent) {
            return;
          }
          event.preventDefault();
          $(tabContent).slideToggle(225);
          tabHeadline.classList.toggle('active');
        });
      });
    });
  }

  function setupPreviews() {
    var elTarget = document.querySelector('.wb-single-product_product-image-container picture');
    if (!elTarget) {
      return;
    }
    var elPreviews = Array.prototype.slice.call(document.querySelectorAll('.wb-single-product_product-image-previews-container img'));
    if (elPreviews.length < 1) {
      return;
    }

    function getWrapper(elPreview) {
      return elPreview.closest('.wb-picture-wrapper[data-index]');
    }

    function getOptions(elWrapper) {
      if (!elWrapper) {
        return;
      }
      switch (elWrapper.dataset.index) {
        case '0':
          return { crop: 'bottom' };
        case '2':
          return { crop: 'top' };
        default:
          return { crop: 'top' };
      }
    }

    function hideWrapper(elWrapper) {
      if (!elWrapper) {
        return;
      }
      elWrapper.style.display = 'none'
    }

    function showWrapper(elWrapper) {
      if (!elWrapper) {
        return;
      }
      elWrapper.style.display = '';
    }

    function showWrappers(except) {
      elPreviews.forEach(function (elPreview) {
        var elWrapper = getWrapper(elPreview);
        if (except === elWrapper) {
          return;
        }
        showWrapper(elWrapper);
      });
    }
    elPreviews.forEach(function (elPreview) {
      var elWrapper = getWrapper(elPreview);
      var options = getOptions(elWrapper);
      elPreview.addEventListener('click', function () {
        window.wbPicture.replaceSrc(elTarget, elPreview.getAttribute('src') || elPreview.getAttribute('data-src'), options);
        hideWrapper(elWrapper);
        showWrappers(elWrapper);
      }, { passive: true });
    });
  }

  function setupMagnify() {
    var elImgZoom = $$('#img-zoom');
    if (elImgZoom.length !== 1) {
      return;
    }

    function onMouseLeave(elImgZoom, event) {
      elImgZoom.transition(0).transform('translate3d(0,0,0) scale(1)').css({ opacity: 0});
    }
    function onMouseMove(elMagnify, elImgZoom, event) {
      var x = Math.min(Math.max((event.offsetX / elMagnify.outerWidth()) * 100, 0), 100);
      var y = Math.min(Math.max((event.offsetY / elMagnify.outerHeight()) * 100, 0), 100);
      elImgZoom.transition(0).css('transformOrigin', x + '% ' + y + '%');
    }
    function onMouseEnter(elMagnify, elImgZoom, event) {
      var src = elMagnify.attr('data-magnify-src') || '';
      elImgZoom.transition(0).css({ backgroundImage: 'url(' + src + ')' }).transform('translate3d(0,0,0) scale(2)').css({ opacity: 1 });
    }

    $$('img[data-magnify-src]').each(function (elIndex, elMagnify) {
      elMagnify = $$(elMagnify);
      elMagnify.on('mouseenter', onMouseEnter.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mousemove', onMouseMove.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mouseleave', onMouseLeave.bind(undefined, elImgZoom), false);
    });
  }

  function setupProductInfoBannerSlider() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('.product-info-banner .swiper-container:not(.swiper-container-initialized)'));
    elements.forEach(function (element) {
      var id = uuidv4();
      element.id = 'product-slider-' + id;
      var swiper = new Swiper(element, {
        navigation: false,
        scrollbar: false,
        navigation: {
          nextEl: '#' + element.id + ' .wb-product-image-slider__nav-next',
          prevEl: '#' + element.id + ' .wb-product-image-slider__nav-prev',
          disabledClass: 'wb-product-image-slider__nav--disabled',
          hiddenClass: 'wb-product-image-slider__nav--disabled'
        },
        scrollbar: {
          el: '.wb-product-image-slider__scrollbar',
          // dragClass: 'wb-product-image-slider__scrollbar-drag',
          enabled: true,
          draggable: false,
          dragSize: 60,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        roundLengths: true,
        // loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          invert: true
        },
        lazyLoad: {
          enabled: true,
          loadPrevNext: true
        },
      });
    });
  }

  setupPreviews();
  setupMagnify();
  setupProductInfoBannerSlider();
}, { passive: true });

window.initCabSlider = function () {
  initProductSlider('#cab_slider');
  initProductSlider('#cab_slider_new');
}

/* aminoProfile script beginn */

document.addEventListener("DOMContentLoaded", () => {

  const profile = document.querySelector('.amino-profile');
  if (!profile) {
    return;
  }

const aminoProfileElements = document.getElementsByClassName("product-aacp__aminoProfile");
const arrowDownElement = document.getElementById("product-aacp__arrowDownID");
const elementsOfProgressBar = document.getElementsByClassName("product-aacp__progress-bar");
const arrowTextID = document.getElementById("product-aacp__arrowDownTextID");
const valuesArray = document.getElementsByClassName("product-aacp__progress-value");
const arrowDownContainer = document.getElementById("product-aacp__arrow-down__element_one");
const arrowDownTextContainer = document.getElementById("product-aacp__arrow-down__element_two");
const servingsBlock = document.getElementsByClassName("product-aacp__servings");
const servingsItemContainer = document.getElementById("product-aacp__servings-item-container");

  if (!servingsItemContainer) {
    return;
  }

var settingFlag = 0;


function isOdd(num) {
    if ((num % 2) == 0) {
        return false;
    }
    return true;
}

var max_height = servingsItemContainer.scrollHeight;



function checkWidth() {
  if (max_height > 650) {
      if (arrowDownElement != null) {
        arrowDownElement.addEventListener("click", showAminoProfile);
      }
      if (arrowTextID != null) {
        arrowTextID.addEventListener("click", showAminoProfile);
      }
    return;
  }
  if (max_height <= 650) {
    arrowDownContainer.style.display = "none";
    arrowDownTextContainer.style.display = "none";
    servingsItemContainer.classList.remove("amino-profile");
    return;
  }
}

checkWidth();


function showAminoProfile() {
    settingFlag += 1;
    if (isOdd(settingFlag)) {
        animateAminoProfile();
        return;
    }
    hideAminoProfile();
}

  function animateAminoProfile() {
    let id = null;
    let pos = 400;
    let len = elementsOfProgressBar.length;
    let elementHeight = 75;
    let deg = 45;
    clearInterval(id);
    id = setInterval(showAnimate, 1);
    function showAnimate() {
        if ((pos >= max_height) && deg >= 225) {
            clearInterval(id);
            arrowDownElement.style.transform = "rotate(225deg)";
            if (arrowTextID.innerHTML == "Mehr anzeigen") {
                arrowTextID.innerHTML = "Weniger anzeigen";
            }
            if (arrowTextID.innerHTML == "View More") {
                arrowTextID.innerHTML = "View Less";
            }
            if (arrowTextID.innerHTML == "En savoir plus") {
                arrowTextID.innerHTML = "Voir moins";
            }

            return;
        }
        else {
            pos += 30;
            deg += 6;
            servingsItemContainer.style.maxHeight = pos + "px";
            arrowDownElement.style.transform = "rotate(" + deg + "deg)";
        }
    }
  }

function hideAminoProfile() {
    let id = null;
    let pos = max_height;
    let deg = 225;
    clearInterval(id);
    id = setInterval(hideAnimate, 1);
    function hideAnimate() {
        if (pos <= 400 && deg <= 45) {
            if (arrowTextID.innerHTML == "Weniger anzeigen") {
                arrowTextID.innerHTML = "Mehr anzeigen";
            }
            if (arrowTextID.innerHTML == "View Less") {
                arrowTextID.innerHTML = "View More";
            }
            if (arrowTextID.innerHTML == "Voir moins") {
                arrowTextID.innerHTML = "En savoir plus";
            }
            clearInterval(id);
            servingsItemContainer.style.maxHeight = "400px";
            arrowDownElement.style.transform = "rotate(45deg)";
            return;
        }
        else {
            pos -= 30;
            deg -= 6;
          servingsItemContainer.style.maxHeight = pos + "px";
            arrowDownElement.style.transform = "rotate(" + deg + "deg)";
        }
    }
}

});

/* aminoProfile script end */

document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.product-add-to-cart-sticky-box');
  if (!el) return;

  var scrolled = false;
  // Detect Safari 26+ on iOS (liquid-glass UI)
  var ua = navigator.userAgent;
  var isIOS = /iPhone|iPad|iPod/.test(ua);
  var safariVersion = ua.match(/Version\/(\d+)/);
  var isLiquidGlass = isIOS && safariVersion && parseInt(safariVersion[1], 10) >= 26;
  var stickyClass = isLiquidGlass ? 'product-add-to-cart-sticky-box-after-scroll-safari' : 'product-add-to-cart-sticky-box-after-scroll';
  var smileClass = isLiquidGlass ? 'smile-launcher-scrolled-safari' : 'smile-launcher-scrolled';

  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 991) {
      var isScrolled = window.scrollY > 0;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        el.classList[scrolled ? 'add' : 'remove'](stickyClass);
        var smileLauncher = document.querySelector('.smile-launcher-frame-container');
        if (smileLauncher ) {
          smileLauncher.classList[scrolled ? 'add' : 'remove'](smileClass);
        }
      }
    }

  }, {passive: true});
})
